<div class="denounce-detail" *ngIf="denounce">

  <!-- Top bar -->
  <div class="top-bar">
    <button mat-icon-button (click)="goBack()" class="back-btn">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="top-bar-main">
      <div class="tracking-id">{{ denounce.trackingId }}</div>
      <div class="top-meta">
        {{ denounce.category }} · {{ denounce.relationship }} · Ingresada {{ denounce.createdAt | date:'dd/MM/yyyy HH:mm' }}
      </div>
    </div>
    <span class="status-chip" [style.background-color]="statusColors[denounce.status]">
      {{ statusLabels[denounce.status] }}
    </span>
  </div>

  <div class="detail-grid">

    <!-- SIDEBAR -->
    <aside class="sidebar">

      <!-- Estado y acciones -->
      <section class="card">
        <h3 class="card-title">Estado</h3>
        <div class="state-badge" [style.background-color]="statusColors[denounce.status]">
          {{ statusLabels[denounce.status] }}
        </div>
        <div class="transitions" *ngIf="getAvailableTransitions().length">
          <div class="transitions-label">Cambiar a:</div>
          <div class="transitions-btns">
            <button *ngFor="let s of getAvailableTransitions()"
                    type="button"
                    class="transition-btn"
                    [style.border-color]="statusColors[s]"
                    [style.color]="statusColors[s]"
                    (click)="changeStatus(s)">
              <mat-icon>arrow_forward</mat-icon>
              {{ statusLabels[s] }}
            </button>
          </div>
        </div>
      </section>

      <!-- Responsable -->
      <section class="card">
        <h3 class="card-title">Responsable</h3>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Asignar a</mat-label>
          <mat-select
            [value]="denounce.assignedTo || ''"
            (selectionChange)="assignOperator($event.value)">
            <mat-option value="">Sin asignar</mat-option>
            <mat-option *ngFor="let op of operators" [value]="op.id">
              {{ op.operatorName }} ({{ op.role }})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </section>

      <!-- Tipo -->
      <section class="card">
        <h3 class="card-title">Tipo de denuncia</h3>
        <div class="type-badge" [class.anon]="denounce.isAnonymous">
          <mat-icon>{{ denounce.isAnonymous ? 'visibility_off' : 'badge' }}</mat-icon>
          {{ denounce.isAnonymous ? 'Anónima' : 'Identificada' }}
        </div>
      </section>

      <!-- Denunciante -->
      <section class="card" *ngIf="!denounce.isAnonymous">
        <h3 class="card-title">Denunciante</h3>
        <dl class="kv">
          <dt>Nombre</dt><dd>{{ denounce.reporterName || '—' }}</dd>
          <dt>Email</dt><dd>{{ denounce.reporterEmail || '—' }}</dd>
          <dt>Teléfono</dt><dd>{{ denounce.reporterPhone || '—' }}</dd>
          <ng-container *ngIf="denounce.reporterDocumentNumber">
            <dt>Documento</dt>
            <dd>{{ denounce.reporterCountryCode }} · {{ denounce.reporterDocumentType }} {{ denounce.reporterDocumentNumber }}</dd>
          </ng-container>
        </dl>
      </section>

      <section class="card anon-note" *ngIf="denounce.isAnonymous">
        <mat-icon>info</mat-icon>
        <p>Los datos del denunciante no están disponibles. La persona puede haber registrado un email privado para recibir notificaciones, pero éste no es visible para el equipo investigador.</p>
      </section>

      <!-- Persona denunciada -->
      <section class="card">
        <h3 class="card-title">Persona denunciada</h3>
        <dl class="kv">
          <dt>Nombre</dt><dd>{{ denounce.accusedName }}</dd>
          <dt>Cargo</dt><dd>{{ denounce.accusedRole || '—' }}</dd>
          <dt>Lugar</dt><dd>{{ denounce.location }}</dd>
          <dt>Fecha suceso</dt><dd>{{ denounce.incidentDate | date:'dd/MM/yyyy' }}</dd>
        </dl>
      </section>

      <!-- Descripción -->
      <section class="card">
        <h3 class="card-title">Descripción</h3>
        <p class="description">{{ denounce.description }}</p>
      </section>

      <!-- Evidencia -->
      <section class="card" *ngIf="denounce.attachments?.length">
        <h3 class="card-title">Evidencia</h3>
        <app-admin-attachment-viewer
          [attachments]="denounce.attachments || []"
          label=""
          (openAttachment)="openAttachment($event)">
        </app-admin-attachment-viewer>
        <p class="helper-text">Click para previsualizar. Los enlaces firmados expiran en 1 hora.</p>
      </section>
    </aside>

    <!-- TIMELINE -->
    <main class="timeline-area">

      <div class="timeline-header">
        <mat-icon>forum</mat-icon>
        <span>Actividad</span>
      </div>

      <div class="timeline">
        <div *ngIf="!timeline.length" class="empty">
          Aún no hay actividad registrada.
        </div>

        <div *ngFor="let it of timeline; trackBy: trackTimeline" class="timeline-item">

          <!-- Mensaje de Admin -->
          <div *ngIf="it.type === 'message' && it.messageAuthorType === 'ADMIN'"
               class="msg admin">
            <div class="avatar">EI</div>
            <div class="bubble">
              <div class="meta">{{ it.messageAuthorName }} · {{ it.at | date:'dd/MM/yyyy HH:mm' }}</div>
              <div class="content">{{ it.messageContent }}</div>
              <div *ngIf="(it.messageAttachments || []).length" class="atts">
                <app-admin-attachment-viewer
                  [attachments]="it.messageAttachments || []"
                  [compact]="true"
                  (openAttachment)="openAttachment($event)">
                </app-admin-attachment-viewer>
              </div>
            </div>
          </div>

          <!-- Mensaje del Denunciante -->
          <div *ngIf="it.type === 'message' && it.messageAuthorType === 'REPORTER'"
               class="msg reporter">
            <div class="avatar">D</div>
            <div class="bubble">
              <div class="meta">{{ it.messageAuthorName }} · {{ it.at | date:'dd/MM/yyyy HH:mm' }}</div>
              <div class="content">{{ it.messageContent }}</div>
              <div *ngIf="(it.messageAttachments || []).length" class="atts">
                <app-admin-attachment-viewer
                  [attachments]="it.messageAttachments || []"
                  [compact]="true"
                  (openAttachment)="openAttachment($event)">
                </app-admin-attachment-viewer>
              </div>
            </div>
          </div>

          <!-- Cambio de estado -->
          <div *ngIf="it.type === 'status'" class="status-event">
            <div class="status-dot" [style.background-color]="statusColors[it.newStatus || '']"></div>
            <div class="status-body">
              <div class="status-text">
                <span *ngIf="it.oldStatus">{{ statusLabels[it.oldStatus] || it.oldStatus }} </span>
                <mat-icon *ngIf="it.oldStatus">arrow_forward</mat-icon>
                <strong>{{ statusLabels[it.newStatus || ''] || it.newStatus }}</strong>
              </div>
              <div class="status-meta">
                {{ it.changedByName }} · {{ it.at | date:'dd/MM/yyyy HH:mm' }}
                <span *ngIf="it.notes" class="status-notes">— "{{ it.notes }}"</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Composer / banner de caso cerrado -->
      <div *ngIf="!isCaseClosed" class="composer">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Escribe un mensaje al denunciante</mat-label>
          <textarea matInput [(ngModel)]="newMessageContent" rows="3" maxlength="5000"></textarea>
          <mat-hint align="end">{{ newMessageContent.length }} / 5000</mat-hint>
        </mat-form-field>
        <div class="composer-row">
          <app-admin-file-uploader [maxFiles]="4" (filesChanged)="messageFiles = $event"></app-admin-file-uploader>
          <button type="button"
                  class="send-btn"
                  (click)="sendMessage()"
                  [disabled]="!newMessageContent.trim()">
            <mat-icon>send</mat-icon>
            Enviar
          </button>
        </div>
      </div>

      <div *ngIf="isCaseClosed" class="closed-banner">
        <mat-icon>lock</mat-icon>
        <span>Caso cerrado. Ya no se pueden enviar más mensajes.</span>
      </div>
    </main>
  </div>
</div>

<!-- Loading -->
<div *ngIf="loading && !denounce" class="flex justify-center py-16">
  <mat-spinner diameter="40"></mat-spinner>
</div>
